import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

const WaIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.533 5.858L.054 23.445a.75.75 0 00.922.922l5.587-1.479A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.7-.506-5.248-1.391l-.378-.22-3.917 1.036 1.036-3.917-.22-.378A9.952 9.952 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
  </svg>
);

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ prenom: '', nom: '', email: '', telephone: '', sujet: '', message: '' });
  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/contact-rapide', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          prenom: form.prenom,
          nom: form.nom,
          email: form.email,
          telephone: form.telephone,
          typeProjet: form.sujet,
          message: form.message,
        }),
      });
      if (!res.ok) throw new Error('Erreur serveur');
      setSent(true);
    } catch {
      setError('Une erreur est survenue. Réessayez ou écrivez-nous directement à contact@apexrenovation.fr');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageSEO
        title="Contact & Devis Gratuit — Châteauroux, Indre (36)"
        path="/contact"
        description="Contactez Apex Rénovation pour votre projet de rénovation à Châteauroux et dans tout le Berry. Réponse sous 24h, devis gratuit et sans engagement. Tél : 02 54 01 23 45."
      />
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">Contact</span>
          </div>
          <h1 className="text-4xl font-extrabold text-white mb-3">Nous contacter</h1>
          <p className="text-slate-400 text-lg">Une question ? Un projet ? Notre équipe vous répond rapidement.</p>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-3 lg:gap-10">
            <div className="lg:col-span-2 mb-10 lg:mb-0">
              {sent ? (
                <div className="bg-white rounded-2xl p-12 text-center border border-slate-200">
                  <div className="text-5xl mb-4">✅</div>
                  <h2 className="text-2xl font-bold text-slate-900 mb-3">Message envoyé !</h2>
                  <p className="text-slate-600 mb-6">Merci ! Nous vous répondons dans les 24h ouvrées.</p>
                  <button onClick={() => setSent(false)} className="bg-orange-600 text-white font-bold px-6 py-3 rounded-lg hover:bg-orange-700 transition-colors">Envoyer un autre message</button>
                </div>
              ) : (
                <div className="bg-white rounded-2xl border border-slate-200 p-8">
                  <h2 className="text-2xl font-bold text-slate-900 mb-6">Envoyez-nous un message</h2>
                  <form className="space-y-5" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">Prénom *</label>
                        <input required type="text" value={form.prenom} onChange={(e) => update('prenom', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500" placeholder="Jean" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">Nom *</label>
                        <input required type="text" value={form.nom} onChange={(e) => update('nom', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500" placeholder="Dupont" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">Téléphone *</label>
                        <input required type="tel" value={form.telephone} onChange={(e) => update('telephone', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500" placeholder="06 12 34 56 78" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">Email *</label>
                        <input required type="email" value={form.email} onChange={(e) => update('email', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500" placeholder="jean@email.fr" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Téléphone</label>
                      <input type="tel" value={form.telephone} onChange={(e) => update('telephone', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500" placeholder="06 XX XX XX XX" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Sujet *</label>
                      <select required value={form.sujet} onChange={(e) => update('sujet', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500 bg-white">
                        <option value="">Choisir un sujet...</option>
                        <option>Demande de devis</option>
                        <option>Question sur une prestation</option>
                        <option>Suivi de chantier</option>
                        <option>Réclamation</option>
                        <option>Recrutement</option>
                        <option>Autre</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Votre message *</label>
                      <textarea required rows={6} value={form.message} onChange={(e) => update('message', e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-orange-500 resize-none" placeholder="Décrivez votre demande..."></textarea>
                    </div>
                    {error && <p className="text-red-600 text-sm">{error}</p>}
                    <button type="submit" disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white font-bold py-3.5 rounded-lg transition-colors">
                      {loading ? 'Envoi en cours…' : 'Envoyer le message →'}
                    </button>
                  </form>
                </div>
              )}
            </div>

            <div className="space-y-5">
              <div className="bg-white rounded-2xl border border-slate-200 p-6">
                <h3 className="font-bold text-slate-900 mb-5">Nos coordonnées</h3>
                <ul className="space-y-4 text-sm">
                  <li className="flex items-start gap-3"><span className="text-orange-500 text-lg mt-0.5">📍</span><div><p className="font-semibold text-slate-900">Adresse</p><p className="text-slate-500">2 rue du Gué de la Chapelle<br />36250 Saint-Maur</p></div></li>
                  <li className="flex items-start gap-3"><span className="text-orange-500 text-lg mt-0.5">✦</span><div><p className="font-semibold text-slate-900">Assistant IA</p><Link to="/assistant" className="inline-flex items-center gap-1.5 text-sm font-semibold text-orange-600 hover:text-orange-700 border border-orange-200 px-3 py-1 rounded-lg hover:bg-orange-50 transition-colors">Poser une question →</Link></div></li>
                  <li className="flex items-start gap-3"><span className="text-orange-500 text-lg mt-0.5">✉️</span><div><p className="font-semibold text-slate-900">Email</p><a href="mailto:contact@apexrenovation.fr" className="text-slate-500 hover:text-orange-600 break-all">contact@apexrenovation.fr</a></div></li>
                  <li className="flex items-start gap-3"><span className="text-orange-500 text-lg mt-0.5">🕐</span><div><p className="font-semibold text-slate-900">Horaires</p><p className="text-slate-500">Lun–Ven : 8h–18h<br />Sam : 9h–12h</p></div></li>
                </ul>
              </div>
              <div className="bg-orange-50 border border-orange-200 rounded-2xl p-6">
                <p className="font-bold text-orange-800 mb-2">Besoin d'un devis ?</p>
                <p className="text-orange-700 text-sm mb-4">Pour une réponse plus rapide, utilisez notre formulaire de devis en ligne.</p>
                <Link to="/devis" className="block text-center bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 rounded-lg transition-colors">Devis gratuit en 2 min</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
